const images = {
  yin: require('./chinese_coin01.png'),
  yang: require('./chinese_coin02.png'),
};

export default images;